<template>
  <v-container>
    <template v-if="!id">
      <v-progress-linear
        indeterminate
      ></v-progress-linear>
    </template>
    <template v-else>
      <div style="text-align: center;">
        <h2>Поздравляем!</h2>
        <br>
        <span class="subtitle-1">Смета успешно создана.</span>
      </div>
      <div class="mt-2" style="text-align: center;">
        <router-link :to="{name: 'SingleEstimate', params: {id: id}}">Перейти к смете</router-link>
      </div>
      <div class="mt-7" style="text-align: center;">
        <v-btn text outlined @click="$emit('reload')">Составить новую смету</v-btn>
      </div>
      
    </template>
    
  </v-container>
</template>

<script>
export default {
  props: {
    id: String
  },
}
</script>